import customersTable from './CustomersTable'
export default customersTable
